export const TEST_COLLECTIONS_ACCESS: Record<string, string[]> = {
  '6787be8c53a64a3ede5bdd47': [
    '0xB54c819Fc22AA4607e7704C41e4D445Aef8Efc60'.toLowerCase(),
  ],
  '6787cb10f669802e759cea48': [
    '0xB54c819Fc22AA4607e7704C41e4D445Aef8Efc60'.toLowerCase(),
  ],
};

export const isWhitelistedCollection = (collectionId: string): boolean => {
  return !!TEST_COLLECTIONS_ACCESS[collectionId];
};

export const hasAccessToCollection = (
  collectionId: string,
  walletAddress?: string,
): boolean => {
  if (!walletAddress) return false;

  const allowedAddresses = TEST_COLLECTIONS_ACCESS[collectionId];
  if (!allowedAddresses) return false;

  const normalizedWalletAddress = walletAddress.toLowerCase();

  return allowedAddresses.includes(normalizedWalletAddress);
};
